import { render, staticRenderFns } from "./Subtitulo.vue?vue&type=template&id=2f25825e&scoped=true&"
import script from "./Subtitulo.vue?vue&type=script&lang=js&"
export * from "./Subtitulo.vue?vue&type=script&lang=js&"
import style0 from "./Subtitulo.vue?vue&type=style&index=0&id=2f25825e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25825e",
  null
  
)

export default component.exports